import Happymood from '../../src/assets/images/mood-img/Happy-border.svg';
import Calmmood from '../../src/assets/images/mood-img/Calm-border.svg';
import Excitedmood from '../../src/assets/images/mood-img/Excited-border.svg';
import Worriedmood from '../../src/assets/images/mood-img/Worried-border.svg';
import Angrymood from '../../src/assets/images/mood-img/Angry-border.svg';
import Scaredmood from '../../src/assets/images/mood-img/Scared-border.svg';
import Confidentmood from '../../src/assets/images/mood-img/Confident-border.svg';
import Annoyedmood from '../../src/assets/images/mood-img/Annoyed-border.svg';
import {
  ANGRY,
  ANNOYED,
  CALM,
  CONFIDENT,
  EXCITED,
  HAPPY,
  SCARED,
  WORRIED,
} from '../constants/moodType.constants';

export const getMoodIcon = (mood) => {
  switch (mood) {
    case HAPPY:
      return Happymood;
    case CALM:
      return Calmmood;
    case EXCITED:
      return Excitedmood;
    case WORRIED:
      return Worriedmood;
    case ANGRY:
      return Angrymood;
    case SCARED:
      return Scaredmood;
    case CONFIDENT:
      return Confidentmood;
    case ANNOYED:
      return Annoyedmood;
    default:
      break;
  }
};
